import { jsx as i } from "react/jsx-runtime";
import * as s from "react";
import { c as n } from "../../utils-BOFVZgHd.js";
const a = s.forwardRef(
  ({ className: e, type: r, ...o }, t) => /* @__PURE__ */ i(
    "input",
    {
      type: r,
      className: n(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--muted-foreground)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: t,
      ...o
    }
  )
);
a.displayName = "Input";
export {
  a as Input
};
//# sourceMappingURL=input.js.map
